interface Props {
  size?: number;
  className?: string;
}

/**
 * Word-document icon — monochrome, uses `currentColor` (inherits from parent).
 * Outlined square with a centered "W" — evokes the Word logo without shipping
 * a colored asset and stays consistent with the rest of the UI (lucide-style).
 */
export function WordIcon({ size = 14, className = '' }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      className={className}
      aria-hidden="true"
    >
      <rect x="3" y="3" width="18" height="18" rx="3" />
      <text
        x="12"
        y="17"
        fontFamily="Arial, Helvetica, sans-serif"
        fontSize="11"
        fontWeight={700}
        fill="currentColor"
        stroke="none"
        textAnchor="middle"
      >
        W
      </text>
    </svg>
  );
}
